// src/domains/di/container.ts
import { Container } from "inversify"

import { ClFarmRepository } from "../cl-farm/cl-farm-repository"
import { TYPES } from "./types"

export const container = new Container()

// Register services - InversifyJS will handle circular dependencies automatically
container.bind<ClFarmRepository>(TYPES.ClFarmRepository).to(ClFarmRepository).inSingletonScope()

// Pools will be bound dynamically in Scale constructor since it needs MinimalPoolRepository
